const protocolsPath = "/asset/protocols/";

export const PROTOCOL_LOGOS = {
    // Protocols
    INFINIFI_CIRC_LOGO: protocolsPath + "infinifi.png",
    PENDLE_LOGO: protocolsPath + "pendle.png",
    CURVE_LOGO: protocolsPath + "curve.png",
    BALANCER_LOGO: protocolsPath + "balancer.svg",
    ETHENA_LOGO: protocolsPath + "ethena.svg",
    STRATA_LOGO: protocolsPath + "strata.svg",
    SILO_LOGO: protocolsPath + "silo.png",
    TAU_LOGO: protocolsPath + "tau.jpg",
    MORPHO_LOGO: protocolsPath + "morpho.svg",
    FLUID_LOGO: protocolsPath + "fluid.png",
    SEAMLESS_LOGO: protocolsPath + "seamless.svg",
    ODYSSEY_LOGO: protocolsPath + "odyssey.svg",
    GEARBOX_LOGO: protocolsPath + "gearbox.png",
} as const;
